(function () {
  function initRoot(root) {
    if (!root || root.dataset.acvMounted === 'true') return;
    root.dataset.acvMounted = 'true';

    var count = parseInt(root.dataset.acvCount || '0', 10);
    if (!count) return;

    var panels = root.querySelectorAll('.about-core-values__panel[data-acv-index]');
    var layers = root.querySelectorAll('.about-core-values__img-layer[data-acv-index]');
    var tabs = root.querySelectorAll('.about-core-values__tab[data-acv-index]');
    var prevBtn = root.querySelector('[data-acv-prev]');
    var nextBtn = root.querySelector('[data-acv-next]');

    var active = 0;

    function setActive(i) {
      var n = ((i % count) + count) % count;
      active = n;

      panels.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-acv-index'), 10);
        var on = idx === n;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      layers.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-acv-index'), 10);
        var on = idx === n;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      tabs.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-acv-index'), 10);
        var on = idx === n;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.tabIndex = on ? 0 : -1;
      });

      // 移动端 tab 横向滚动区域跟随当前选中项（与 CSS max-width: 1023px 一致）
      if (window.matchMedia('(max-width: 1023px)').matches) {
        var activeTab = root.querySelector('.about-core-values__tab[data-acv-index="' + n + '"]');
        if (activeTab) {
          var instant =
            typeof window.matchMedia === 'function' &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          activeTab.scrollIntoView({
            behavior: instant ? 'instant' : 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      }
    }

    var mqHover = window.matchMedia('(hover: hover)');

    tabs.forEach(function (tab) {
      var idx = parseInt(tab.getAttribute('data-acv-index'), 10);
      tab.addEventListener('click', function () {
        setActive(idx);
      });
      tab.addEventListener('mouseenter', function () {
        if (mqHover.matches) {
          setActive(idx);
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        setActive(active - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        setActive(active + 1);
      });
    }
  }

  function mountAll() {
    document.querySelectorAll('[data-about-core-values]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-about-core-values]');
    if (root) {
      delete root.dataset.acvMounted;
      initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-about-core-values]');
    if (root) {
      delete root.dataset.acvMounted;
    }
  });
})();
